module.exports = __webpack_public_path__ + "files/0f49b977679e50d71de5bbbd633e9809.png";